<template>
  <div class="max-w-6xl mx-auto text-center pb-12">
    <h1 class="text-2xl font-bold">Great, now let's set up your billing.</h1>
    <p class="text-lg mb-12">
      Pick the subscription that best fits your team's needs. You can always upgrade or downgrade at a later time.
    </p>
    <stripe-pricing-table
      :pricing-table-id="pricingTableId"
      :publishable-key="stripePublishableKey"
      :customer-email="currentUser.email"
    >
    </stripe-pricing-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { pricingTableId, stripePublishableKey } from '../../../../utilities/pricingTable';

export default {
  computed: {
    ...mapState(['currentUser']),
    pricingTableId() {
      return pricingTableId;
    },
    stripePublishableKey() {
      return stripePublishableKey;
    },
  },
};
</script>
